import AvatarPlaceholder from 'common/AvatarPlaceholder/AvatarPlaceholder';
import './CoachCard.css';
import '../../Catalog.css';

/**
 * Картка тренера — ADR-0015.
 *
 * Було: клуб і кількість учнів. Джерело більше не віддає ані того, ані того.
 * Найвищий клас, який тренер веде, теж не показуємо — у переліку лишається
 * тільки ім'я.
 */
export default function CoachCard({ coach }) {
  const surname = (coach.surname || '').trim();
  const name = (coach.name || '').trim();

  return (
    <div className='catalog-card coach-card'>
      <div className='img-wrapper'>
        {coach.avatar ? <img src={coach.avatar} alt='' loading='lazy' /> : <AvatarPlaceholder />}
      </div>

      <div className='card-body'>
        <h2 className='card-name'>
          {surname} {name}
        </h2>
      </div>
    </div>
  );
}
